export class KeychainError extends Error {
    code;
    /** HTTP status for `server` errors; 0 when the request never reached the server. */
    status;
    constructor(code, message, status = 0) {
        super(message);
        this.name = 'KeychainError';
        this.code = code;
        this.status = status;
    }
}
export function isKeychainError(e, code) {
    return e instanceof KeychainError && (code === undefined || e.code === code);
}
//# sourceMappingURL=errors.js.map